<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 align-items-center justify-content-between mb-3">
  <span class="p-input-icon-right">
    <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" />
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="clearFilters()"></i>
  </span>
  <p-button label="Nuevo DDI" icon="pi pi-plus" (click)="edit(null)"></p-button>
</div>
-->

<p-table #grid [value]="ddis" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
  [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
  [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
      <th pSortableColumn="phoneNumber">Teléfono <p-sortIcon field="phoneNumber"></p-sortIcon></th>
      <th width="100">Activo</th>
      <th>Plan de llamada</th>
      <th width="120"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-ddi>
    <tr (dblclick)="edit(ddi.id)" class="cursor-pointer">
      <td>{{ddi.name}}</td>
      <td>{{ddi.phoneNumber}}</td>
      <td>
        <i class="pi" [ngClass]="ddi.active ? 'pi-check-circle text-green-500' : 'pi-times-circle text-red-500'"></i>
      </td>
      <td>{{ddi.dialPlanId ? dialPlanNames[ddi.dialPlanId] : '—'}}</td>
      <td>
        <div class="flex gap-2 justify-content-end">
          <p-button (click)="delete(ddi)" [rounded]="true" [text]="false" severity="danger"
            pTooltip="Eliminar DDI" tooltipPosition="top">
            <i class="pi pi-trash"></i>
          </p-button>
          <p-button (click)="edit(ddi.id)" [rounded]="true" [text]="false"
            pTooltip="Editar DDI" tooltipPosition="top">
            <i class="pi pi-pencil"></i>
          </p-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">No se han encontrado DDIs</td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>
